// Typelizer digest cce90f1153917be2f0e39962b3c46c34
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /workspace */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/workspace', {}, options),
    method: 'get',
  }),
}
